import React from "react";
import {Routes} from "ubcommunity-shared/src/constants/routes";
import RelativeRoute from "ubcommunity-shared/src/Navigation/RelativeRoute/RelativeRoute";
import RelativeRedirect from "ubcommunity-shared/src/Navigation/RelativeRedirect/RelativeRedirect";
import RelativeSwitch from "ubcommunity-shared/src/Navigation/RelativeSwitch/RelativeSwitch";
import useAuth from "ubcommunity-shared/src/Auth/hooks/useAuth";
import {VerifyEmail} from "ubcommunity-shared/src/Auth/VerifyEmail/VerifyEmail";
import {useIsDesktop} from "ubcommunity-shared/src/General/useIsDesktop/useIsDesktop";
import {SSOSuccess} from "ubcommunity-shared/src/Auth/SSO/SSOSuccess";
import {SSOProvider} from "ubcommunity-shared/src/Auth/SSO/SSOProvider";
import {DesktopAuthLayout} from "../../Layout/DesktopAuthLayout/DesktopAuthLayout";
import Login from "../Login/Login";
import Landing from "../Landing/Landing";
import {LandingV2, DesktopLandingV2} from "../LandingV2";
import SignupStep1 from "../Signup/SignupStep1";
import {RequestResetPassword} from "../ResetPassword/RequestResetPassword";
import {ChangePasswordForm} from "../ResetPassword/ChangePasswordForm";
import {ChangePassword} from "../ResetPassword/ChangePassword";
import {SSO} from "../SSO/SSO";

export default function AuthRoutes() {
    const {isDesktop} = useIsDesktop();
    const {isLoggedIn, isVerified} = useAuth();

    if (isLoggedIn() && !isVerified()) {
        return isDesktop ? (
            <DesktopAuthLayout>
                <VerifyEmail />
            </DesktopAuthLayout>
        ) : (
            <VerifyEmail />
        );
    }

    return <SSOProvider>{isDesktop ? <DesktopAuthRoutes /> : <MobileAuthRoutes />}</SSOProvider>;
}

const WithBackGroundLayout = ({component}) => {
    return <DesktopAuthLayout>{component}</DesktopAuthLayout>;
};

const DesktopAuthRoutes = () => {
    return (
        <>
            <RelativeSwitch>
                <RelativeRoute path={Routes.LANDING}>
                    <WithBackGroundLayout component={<Landing />} />
                </RelativeRoute>
                <RelativeRoute path={Routes.LOGIN}>
                    <WithBackGroundLayout component={<Login />} />
                </RelativeRoute>
                <RelativeRoute path={Routes.SSO_SUCCESS}>
                    <WithBackGroundLayout component={<SSOSuccess />} />
                </RelativeRoute>
                <RelativeRoute path={Routes.SSO_LOGIN}>
                    <WithBackGroundLayout component={<SSO />} />
                </RelativeRoute>
                <RelativeRoute path={Routes.SIGNUP_STEP_1}>
                    <WithBackGroundLayout component={<SignupStep1 />} />
                </RelativeRoute>
                <RelativeRoute path={Routes.CHANGE_PASSWORD}>
                    <WithBackGroundLayout component={<ChangePasswordForm />} />
                </RelativeRoute>
                <RelativeRoute path={Routes.REQUEST_RESET}>
                    <WithBackGroundLayout component={<RequestResetPassword />} />
                </RelativeRoute>
                <RelativeRoute path={Routes.BASE_AUTH}>
                    <DesktopLandingV2 />
                </RelativeRoute>
                <RelativeRoute path="/">
                    <RelativeRedirect to={Routes.BASE_AUTH} />
                </RelativeRoute>
            </RelativeSwitch>
        </>
    );
};

const MobileAuthRoutes = () => {
    return (
        <>
            <RelativeSwitch>
                <RelativeRoute path={Routes.LOGIN}>
                    <Login />
                </RelativeRoute>
                <RelativeRoute path={Routes.SIGNUP_STEP_1}>
                    <SignupStep1 />
                </RelativeRoute>
                <RelativeRoute path={Routes.SSO_SUCCESS}>
                    <SSOSuccess />
                </RelativeRoute>
                <RelativeRoute path={Routes.SSO_LOGIN}>
                    <SSO />
                </RelativeRoute>
                <RelativeRoute path={Routes.REQUEST_RESET}>
                    <RequestResetPassword />
                </RelativeRoute>
                <RelativeRoute path={Routes.CHANGE_PASSWORD}>
                    <ChangePassword />
                </RelativeRoute>
                <RelativeRoute path={Routes.BASE_AUTH}>
                    <LandingV2 />
                </RelativeRoute>
                <RelativeRoute path="/">
                    <RelativeRedirect to={Routes.BASE_AUTH} />
                </RelativeRoute>
            </RelativeSwitch>
        </>
    );
};
